import React from "react";
import { Thumbnail } from "@culturehq/components";

const UserThumbnail = ({ user: { name, avatar: { thumbUrl } } }) => (
  <Thumbnail className="Thumbnail pull-left" image={thumbUrl} title={name} />
);

export default UserThumbnail;
